
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"17.427","height":"17.432","viewBox":"0 0 17.427 17.432"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.317.315a1.1 1.1 0 00-.261 1.119l5.085 15.26a1.087 1.087 0 001.032.741h.024a1.081 1.081 0 001.024-.785l2.105-7.319 7.316-2.107a1.088 1.088 0 00.036-2.078L1.422.061A1.058 1.058 0 00.317.315z","fill":"#fff"}})])
          )
        }
      }
    